import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Layout from '../../components/layout'
import SEO from '../../components/seo'
import useQueryParam from '../../hooks/useQueryParam'
import PostSidebar from '../../components/post-sidebar'

interface LocationState {
  email: string
}
interface Location {
  state?: LocationState
}
interface Props {
  location?: Location
  data: any
}

export const postData = graphql`
  query getPost($id: String) {
    post: wpContentNode(id: { eq: $id }) {
      ... on WpPost {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        ...AuthorFields
        ...SeoFields
      }

      ... on WpProductguide {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        ...AuthorFields
        ...SeoFields
      }
      ... on WpCasestudy {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        ...AuthorFields
        ...SeoFields
      }
      ... on WpInfographic {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        ...AuthorFields
        ...SeoFields
      }
    }
    form: wpGfForm(databaseId: { eq: 2 }) {
      ...GravityFormFields
    }
    wp {
      themeOptions {
        acfOptions {
          hubspotSubscribeTitle
          hubspotSubscribeDescription
          gravityFormEnabled
          gravityFormId
          pardotFormHandlerUrl
          redirectUrl
          gravityFormInputCssClasses
          gravityFormLabelCssClasses
          gravityFormButtonText
          gravityFormButtonCssClasses
        }
      }
    }
  }
`

const Post: React.FC<Props> = ({ location, data }) => {
  const [pardotEmailQuery, setPardotEmailQueryParam] = useQueryParam('pi_list_email', '', true)
  const emailQueryParam = location?.state?.email ? location?.state?.email : ''
  useEffect(() => {
    if (emailQueryParam) {
      setPardotEmailQueryParam(emailQueryParam)
      window.location.reload()
    }
  }, [])

  const gravityFormId = data?.wp?.themeOptions?.acfOptions?.gravityFormId
    ? data?.wp?.themeOptions?.acfOptions?.gravityFormId
    : ''

  const gravityFormEnabled = data?.wp?.themeOptions?.acfOptions?.gravityFormEnabled
    ? data?.wp?.themeOptions?.acfOptions?.gravityFormEnabled
    : ''

  return (
    <Layout location={location} className={`post post-${data?.post?.nodeType?.toLowerCase()}`}>
      <SEO
        seo={data?.post?.seo}
        url={data?.post?.link}
        featuredImage={data?.post?.featuredImage?.node?.sourceUrl}
        isBlogPost={true}
      />
      <div className='content-single max-w-screen-2xl mx-auto'>
        <div className='content-single__main overflow-hidden p-12'>
          <h1>{data?.post?.title}</h1>

          {/* Hide featured image for case studies and infographics */}
          {data?.post?.featuredImage &&
          data?.post?.nodeType.toLowerCase() !== 'casestudy' &&
          data?.post?.nodeType.toLowerCase() !== 'infographic' ? (
            <img
              className='mb-12 rounded-3xl w-full'
              src={data?.post?.featuredImage?.node?.sourceUrl}
              alt={data?.post?.featuredImage?.node?.altText}
            />
          ) : (
            ''
          )}
          <div className='text-gray' dangerouslySetInnerHTML={{ __html: data?.post?.content }} />
        </div>
        <PostSidebar data={data} />
      </div>
    </Layout>
  )
}

export default Post
